import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showMFA: false,
  mfaEmail: null,
  mfaTime: null,
};

export const mfaSlice = createSlice({
  name: "mfa",
  initialState,
  reducers: {
    setShowMFA: (state, action) => {
      state.showMFA = action.payload
    },
    setMFAEmail: (state, action) => {
      state.mfaEmail = action.payload
    },
    setMFATime: (state, action) => {
      state.mfaTime = action.payload
    },
    resetMFATime: (state) => {
      state.mfaTime = null
    }
  },
});

export const { setShowMFA, setMFAEmail, setMFATime, resetMFATime} = mfaSlice.actions;
export default mfaSlice.reducer;